function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import debounce from "lodash/debounce";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { InputEl } from "common/components/input";
import { toCurrency } from "media/js/pricing/plan-builder-2023/common/util";
import { TrackingEvents } from "media/js/pricing/tracking";
import inputStyleOverride from "./input-marketing.inline.styl";
export function template() {
  var _this$app$state, _this$app$state2, _this$app$state3;
  const selectedCapString = this.app.helpers.getSelectedCapAbbreviated();
  const billingPeriod = this.app.helpers.getBillingPeriodString();
  const selectedPlanPrice = (_this$app$state = this.app.state) === null || _this$app$state === void 0 || (_this$app$state = _this$app$state.amountDueInfo) === null || _this$app$state === void 0 ? void 0 : _this$app$state.amount;
  const showNotChargedToday = ((_this$app$state2 = this.app.state) === null || _this$app$state2 === void 0 ? void 0 : _this$app$state2.amountDueInfo) && ((_this$app$state3 = this.app.state) === null || _this$app$state3 === void 0 || (_this$app$state3 = _this$app$state3.amountDueInfo) === null || _this$app$state3 === void 0 ? void 0 : _this$app$state3.amount) === 0;
  const {
    showEmailInput,
    emailValidationError,
    emails,
    purchaseBtnLoading,
    purchaseBtnDisabled
  } = this.state;
  const {
    billingCard
  } = this.app.state;
  const overagePrice = this.app.helpers.getOveragePricePerEventString();
  const renderDetails = () => {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".step-title" }, "Confirm your details"), /* @__PURE__ */ jsx("div", { sel: ".section-title.bold" }, "Plan"), /* @__PURE__ */ jsx("div", { sel: ".section-description" }, selectedCapString, " Event volume per month"), /* @__PURE__ */ jsx("div", { sel: ".section-caption" }, overagePrice && /* @__PURE__ */ jsx("span", null, "Additional events will be charged at ", overagePrice, " and billed the following month.")), /* @__PURE__ */ jsx("div", { sel: ".section-title.bold" }, "Billing Period"), /* @__PURE__ */ jsx("div", { sel: ".section-description" }, billingPeriod), /* @__PURE__ */ jsx("div", { sel: ".section-caption" }, "Renews: ", this.app.helpers.getRenewalDate()), /* @__PURE__ */ jsx("div", { sel: ".section-title.bold" }, "Payment"), billingCard && /* @__PURE__ */ jsx("div", { sel: ".section-description" }, /* @__PURE__ */ jsx("div", null, "".concat(billingCard.type, " \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 ").concat(billingCard.last4)), /* @__PURE__ */ jsx("div", null, "Expires ", "".concat(billingCard.expiryMonth, "/").concat(billingCard.expiryYear))));
  };
  return /* @__PURE__ */ jsx("div", { sel: ".review-wrapper", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("mp-2023-style") ? renderDetails() : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: ".step-title" }, "Plan Summary"), /* @__PURE__ */ jsx("div", { sel: ".plan-info" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "checkmark"
  }, sel: ".checkmark-icon" }), /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("span", { sel: ".mp-font-size-large" }, "Mixpanel Plan: "), " ", selectedCapString, " Event volume per month")), /* @__PURE__ */ jsx("div", { sel: ".plan-info" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "checkmark"
  }, sel: ".checkmark-icon" }), /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("span", { sel: ".mp-font-size-large" }, "New Plan Term: "), " ", billingPeriod)), /* @__PURE__ */ jsx("div", { sel: ".step-description" }, overagePrice && /* @__PURE__ */ jsx("span", null, "Additional data (Events) will be charged at ", overagePrice, " and billed the following month."))), /* @__PURE__ */ jsx("div", { sel: ".payment-method-section" }, /* @__PURE__ */ jsx("div", { sel: ".step-title" }, "Payment Method"), billingCard && /* @__PURE__ */ jsx("div", { sel: ".step-description" }, /* @__PURE__ */ jsx("div", null, "".concat(billingCard.type, " \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 ").concat(billingCard.last4)), /* @__PURE__ */ jsx("div", null, "Expires ", "".concat(billingCard.expiryMonth, "/").concat(billingCard.expiryYear))))), !showEmailInput && /* @__PURE__ */ jsx("div", { sel: ".send-recipients-wrapper", on: {
    click: () => {
      this.helpers.setShowEmailInput(true);
    }
  } }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "email"
  } })), /* @__PURE__ */ jsx("div", { sel: ".send-recipients-text" }, "Send billing receipts to additional team members ".concat(emails && "(".concat(emails, ")")))), showEmailInput && /* @__PURE__ */ jsx("div", { sel: ".emails-input-area" }, /* @__PURE__ */ jsx(InputEl, { attrs: _objectSpread(_objectSpread({
    placeholder: "List of emails separated by comma",
    "auto-focus": true
  }, emailValidationError && {
    "validation-status": "invalid",
    "error-message": emailValidationError
  }), {}, {
    "style-override": this.attr("mp-2023-style") ? inputStyleOverride : ""
  }), on: {
    input: debounce((ev) => {
      this.helpers.setEmailRecipients(ev.target.value);
    }, 300),
    focus: () => {
      if (emails) {
        const emailsInput = document.querySelector("mp-input");
        emailsInput.value = emails;
      }
    }
  } }), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: this.attr("mp-2023-style") ? ButtonTheme.MarketingSecondary : ButtonTheme.Secondary,
    role: "button",
    tabindex: 0
  }, sel: ".cancel-btn", on: {
    click: () => {
      this.helpers.setEmailValidationError(null);
      this.helpers.setShowEmailInput(false);
    }
  } }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: this.attr("mp-2023-style") ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
    role: "button",
    tabindex: 0
  }, sel: ".save-btn", on: {
    click: this.helpers.handleInputGroupSubmit
  } }, "Save")), this.attr("mp-2023-style") && showNotChargedToday && /* @__PURE__ */ jsx("div", { sel: ".info-icon-area" }, /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")), /* @__PURE__ */ jsx("div", { sel: ".review-btn-area" }, purchaseBtnDisabled && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: "Please confirm your payment info is correct",
    placement: Placement.Left
  } }), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: this.attr("mp-2023-style") ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
    role: "button",
    tabindex: 0,
    disabled: purchaseBtnLoading || purchaseBtnDisabled,
    size: ButtonSize.Large
  }, on: {
    // Customers with existing plans need to hit the change endpoint
    click: () => {
      if (!purchaseBtnLoading) {
        this.app.state.customerInfo.orgInfo.arr || this.app.state.customerInfo.orgInfo.isPaid ? this.helpers.changePlan() : this.helpers.purchasePlan();
      }
    }
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "".concat(purchaseBtnLoading ? "Processing" : "Complete Purchase ".concat(toCurrency(selectedPlanPrice)))), this.attr("mp-2023-style") && /* @__PURE__ */ jsx("a", { sel: ".support-btn", attrs: {
    role: "button",
    tabindex: 0,
    href: "/get-support",
    target: "_blank"
  }, on: {
    click: () => this.app.helpers.trackEventWithPlanProps(TrackingEvents.ContactSupport)
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-help"
  } }), "Contact support"), !this.attr("mp-2023-style") && showNotChargedToday && /* @__PURE__ */ jsx("div", { sel: ".info-icon-area" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, sel: ".info-icon" }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file."))));
}
